<script setup lang="ts">
import Tooltip from '@/components/Tooltip.vue'
import {useKnowledgeBaseUrl} from '../../composables/useKnowledgeBaseUrl'
import {useReleaseNotesUrl} from '@/composables/useReleaseNotesUrl'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'
import {useI18n} from 'vue-i18n'

const {href} = useKnowledgeBaseUrl()
const {href: releaseNotesHref} = useReleaseNotesUrl()
const {t} = useI18n()
const isNewUiEnabled = useNewUiEnabled()
</script>

<template>
  <Tooltip :class="{'px-3': !isNewUiEnabled}">
    <i
      :class="[
        'fa-solid fa-circle-question text-white cursor-pointer',
        isNewUiEnabled ? 'text-new-lg leading-none' : 'text-3xl mt-1',
      ]"
    ></i>
    <template #tooltip-content>
      <div class="flex flex-col gap-y-1">
        <a class="flex items-center" :href="href" rel="noopener noreferrer" target="_blank">
          {{ t('header.knowledgeBase') }}
          <i class="fa-solid fa-arrow-up-right-from-square ml-1.5"></i>
        </a>
        <a class="flex items-center" :href="releaseNotesHref" rel="noopener noreferrer" target="_blank">
          {{ t('header.releaseNotes') }}
          <i class="fa-solid fa-arrow-up-right-from-square ml-1.5"></i>
        </a>
      </div>
    </template>
  </Tooltip>
</template>
